/**
 * Texts for User Training page - French Canada
 */
export const userTrainingPageText = {
    title: 'Formation utilisateur - CamAPS FX',
    titleMeta: 'Ressources de formation complètes pour les utilisateurs de CamAPS FX',
    descriptionMeta: 'Accédez aux supports de formation complets, tutoriels vidéo, guides d\'utilisation et webinaires pour tirer le meilleur parti de CamAPS FX.',
    keywords:
        'formation camaps fx, formation camaps, formation diabète, formation pompe à insuline, guide utilisateur, tutoriels vidéo',
    localeMeta: 'fr_ca',

    mainHeader: 'Formation utilisateur',
    mainSubHeader: 'Complétez la formation essentielle dans l\'application avant d\'utiliser l\'application CamAPS FX.',

    gettingStartedHeader: 'Premiers pas',
    step1Title: '<strong>Étape 1:</strong><br/>Téléchargez l\'application',
    step2Title: '<strong>Étape 2:</strong><br/>Créez un compte',
    step3Title: '<strong>Étape 3:</strong><br/>Commencez la formation essentielle dans l\'application',
    step4Title: '<strong>Étape 4:</strong><br/>Associez votre pompe et CGM choisis (avec l\'approbation de votre équipe soignante) ou explorez l\'application en <strong>mode virtuel</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Besoin d\'aide pour installer l\'application?',
    supportSectionText: 'Visitez notre section support pour obtenir de l\'aide',
    supportButtonText: 'ASSISTANCE',
    findOutMoreButtonText: 'EN SAVOIR PLUS',

    additionalResourcesTitle: 'Ressources supplémentaires',
    additionalResourcesSubtitle: 'Apprenez grâce à des visuels étape par étape ou regardez des sessions dirigées par des experts sur l\'utilisation de l\'application.',
    
    animationsTitle: 'Animations',
    animationsDescription: 'La pompe à insuline Dana n\'est actuellement disponible commercialement qu\'avec CamAPS FX au Royaume-Uni. Toutes les ressources liées à Dana sont donc disponibles uniquement en anglais.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',

    webinarsTitle: 'Webinaires',
    webinarsDescription: 'Ces webinaires conviennent aux personnes atteintes de diabète de type 1, à leur famille et à leurs aidants, ainsi qu\'aux enseignants, au personnel de soutien à l\'éducation et aux professionnels de la santé. Ils sont présentés en anglais.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Fiches d\'information',
    factsheetsDescription: 'La pompe à insuline Dana n\'est actuellement disponible commercialement qu\'avec CamAPS FX au Royaume-Uni. Toutes les ressources liées à Dana sont donc disponibles uniquement en anglais.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'Formation dans l\'application',
    inAppTrainingText: 'Commencez par la formation essentielle intégrée à l\'application CamAPS FX. Cette formation interactive vous guidera à travers toutes les fonctionnalités clés que vous devez connaître.<br/><br/><strong>Pour accéder:</strong> Téléchargez l\'application CamAPS FX et créez un compte pour commencer votre formation dans l\'application.',

    gettingStartedText: '<strong>Étape 1:</strong> Téléchargez l\'application CamAPS FX depuis le magasin d\'applications de votre appareil<br/><strong>Étape 2:</strong> Créez votre compte<br/><strong>Étape 3:</strong> Complétez les modules de formation dans l\'application<br/><strong>Étape 4:</strong> Connectez votre pompe à insuline et CGM<br/><strong>Étape 5:</strong> Commencez votre parcours CamAPS FX',

    trainingResourcesHeader: 'Ressources de formation supplémentaires',
    videoTutorialsText: 'Tutoriels vidéo',
    videoTutorialsDesc: 'Regardez des guides vidéo étape par étape couvrant la configuration, l\'utilisation quotidienne et le dépannage.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Guides d\'utilisation & Documentation',
    userGuidesDesc: 'Téléchargez des guides PDF complets et des documents de référence rapide.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Webinaires en direct',
    webinarsDesc: 'Rejoignez des sessions de formation dirigées par des experts et des opportunités de questions-réponses.',

    needHelpHeader: 'Besoin d\'aide?',
    needHelpTextStart: 'Si vous avez besoin d\'assistance ou avez des questions, visitez notre page',
    supportLinkText: 'Support',
    needHelpTextEnd: 'pour obtenir de l\'aide supplémentaire et des informations de contact.'
};

